module.exports = __webpack_public_path__ + "media/icons/login@2x-81975a55.png";